import * as React from "react"
export const Svg_066 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={58}
    height={59}
    fill="none"
  >
    <path
      fill="url(#a)"
      d="M35.355 18.373v-.52h-8.844c-2.132 0-3.867 1.765-3.867 3.934v.685h8.682c2.222 0 4.03-1.839 4.03-4.099Z"
    />
    <path
      fill="url(#b)"
      d="M27.3 46.962v-7.504h-4.248L23.05 49.78h11.896v-10.32H30.7v7.502h-3.4Z"
    />
    <path
      fill="url(#c)"
      d="M43.456 49.779v-4.801c-.063-2.906-2.294-5.277-5.109-5.502l-.001 10.303h5.11Z"
    />
    <path
      fill="url(#d)"
      d="M14.542 45.104v4.675h5.11V39.476c-2.855.229-5.11 2.666-5.11 5.628Z"
    />
    <path
      fill="url(#e)"
      d="M22.644 25.93v4.176c0 3.25 2.6 5.895 5.795 5.895h1.122c3.195 0 5.795-2.645 5.795-5.895V24.72a7.296 7.296 0 0 1-4.03 1.211h-8.682Z"
    />
    <path
      fill="url(#f)"
      d="M5.47 0v59h47.06V0H5.47Zm41.386 53.237H11.142V5.763h35.713v47.474Z"
    />
    <path
      fill="url(#g)"
      d="M14.54 9.221v28.747a8.812 8.812 0 0 1 5.552-1.967h1.214a9.408 9.408 0 0 1-2.06-5.895v-8.319c0-4.075 3.259-7.391 7.265-7.391h12.244v15.71a9.408 9.408 0 0 1-2.061 5.895h1.214c2.094 0 4.022.735 5.548 1.965V9.221H14.541Z"
    />
    <defs>
      <linearGradient
        id="a"
        x1={25.584}
        x2={26.632}
        y1={18.546}
        y2={23.217}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="b"
        x1={25.802}
        x2={30.367}
        y1={41.007}
        y2={49.523}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={39.528}
        x2={44.87}
        y1={41.022}
        y2={45.31}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="d"
        x1={15.723}
        x2={21.066}
        y1={41.022}
        y2={45.311}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="e"
        x1={25.584}
        x2={30.636}
        y1={26.411}
        y2={35.624}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="f"
        x1={16.353}
        x2={46.695}
        y1={8.85}
        y2={48.018}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="g"
        x1={21.227}
        x2={34.847}
        y1={13.533}
        y2={35.704}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
    </defs>
  </svg>
)